import SectionFaq from './SectionFaq'

export default SectionFaq
